<script>
export default {
  props: {
    dataList: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
}
</script>
<template>
  <div :class="$style.welfareCard">
    <div class="welfareCard__box">
      <div class="container">
        <div class="welfareCard-box">
          <div class="left">
            <p class="title">{{ dataList.title }}<span class="bottom-line"></span></p>
          </div>
          <div class="right">
            <div v-for="(item, index) of dataList.list" :key="index" class="inner-right"
              ><p class="circle"></p><p>{{ item }}</p></div
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.welfareCard {
  :global {
    .welfareCard {
      &__box {
        .container {
          background-color: #ffffff;
          box-shadow: 0px 2px 4px 2px #21455829;
          border: 1px solid #21455829;
          .welfareCard-box {
            padding: 70px 10px;
            display: flex;
            .left {
              width: 25%;
              margin-left: 100px;
              .title {
                position: relative;
                font-size: 24px;
                color: $color-gray-8;
                word-break: keep-all;
                &::before {
                  position: absolute;
                  bottom: -20px;
                  left: 0;
                  width: 5px;
                  height: 5px;
                  content: '';
                  background-color: $color-primary;
                  border-radius: 50%;
                  @include max-md {
                    bottom: -0.875rem;
                  }
                  @include max-sm {
                    left: 15px;
                  }
                }
                &::after {
                  position: absolute;
                  bottom: -20px;
                  left: 10px;
                  width: 5px;
                  height: 5px;
                  content: '';
                  background-color: $color-primary;
                  border-radius: 50%;
                  @include max-md {
                    bottom: -0.875rem;
                  }
                  @include max-sm {
                    left: 25px;
                  }
                }
                .bottom-line {
                  position: absolute;
                  bottom: -20px;
                  left: 20px;
                  width: 30px;
                  height: 5px;
                  background-color: $color-primary;
                  border-radius: 4px;
                  @include max-md {
                    bottom: -0.875rem;
                  }
                  @include max-sm {
                    left: 35px;
                  }
                }
              }
              @include max-lg {
                margin-left: 50px;
              }
              @include max-md {
                margin-left: 0;
                display: flex;
                justify-content: center;
              }
            }
            .right {
              width: 50%;
              display: flex;
              flex-direction: column;
              color: $color-gray-6;
              .inner-right {
                display: flex;
                align-items: center;
              }
              .circle {
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 10px;
                background-color: $color-primary;
                margin-right: 17px;
                flex-shrink: 0;
              }
              @include max-md {
                margin-top: 20px;
                width: 85%;
              }
            }
            @include max-md {
              flex-direction: column;
              align-items: center;
            }
          }
        }
      }
    }
  }
}
</style>